import { cx } from '@linaria/core';
import { resets } from '@ui/css';
import { Chevron } from '@utils/react';
import { chevron, button } from './arrow.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ArrowButton({
  as,
  ...props
}) {
  const Comp = as ?? "button";
  return /*#__PURE__*/jsxs(Comp, {
    ...props,
    ref: props.ref,
    className: cx(resets.rootCls, button, props.className),
    children: [props.children, /*#__PURE__*/jsx(Chevron, {
      className: chevron,
      size: 11,
      lineWidth: 2
    })]
  });
}

export { ArrowButton };
//# sourceMappingURL=arrow.js.map
